import { render } from "./InputRepeaterBarang.vue?vue&type=template&id=63bdb5ca"
import script from "./InputRepeaterBarang.vue?vue&type=script&lang=js"
export * from "./InputRepeaterBarang.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__